"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const spinnerStyles_1 = __importDefault(require("./spinnerStyles"));
const Spinner = () => (react_1.default.createElement(react_native_1.View, { style: [spinnerStyles_1.default.container] },
    react_1.default.createElement(react_native_1.ActivityIndicator, { size: "large", color: colors_1.default.FONT_BLACK })));
exports.default = Spinner;
